<ion-header>
  <ion-toolbar mode="md"
               color="dark">
    <ion-title>Item Options</ion-title>
  </ion-toolbar>
</ion-header>
<ng-container *ngIf="isSelfService; else normalModal">
  <div class="inner-content">
    <ng-container *ngTemplateOutlet="contentTmpl"></ng-container>
  </div>
</ng-container>

<ng-template #normalModal>
  <ion-content class="ion-no-padding">
    <ng-container *ngTemplateOutlet="contentTmpl"></ng-container>
  </ion-content>
</ng-template>

<ion-footer>
  <div class="footer-buttons">
    <ion-button color="dark" (click)="onClose()">
      Cancel
    </ion-button>
    <ion-button color="moonstone" (click)="onSave()">
      Continue with order
    </ion-button>
  </div>
</ion-footer>

<ng-template #contentTmpl>
  <ng-template #optLabel let-option="option">
    <!-- this case should not happened in our application, just put it to show incase we have issue -->
    <ion-label>
      <div class="flex ion-align-items-center">
        {{option.text_label}}
        <ion-chip *ngIf="option.added_price && +option.added_price"
                  color="moonstone ion-no-margin ion-margin-start">{{+option.added_price |
          currency}}
        </ion-chip>
      </div>
    </ion-label>
  </ng-template>
  <ion-list class="ion-no-padding">
    <h4 class="ion-margin">{{item.name}}</h4>
    <ion-accordion-group [multiple]="true" expand="inset" mode="md" [value]="openedAccordions">
      <ion-accordion *ngFor="let prompt of selectedPrompts" [value]="prompt.id">
        <ion-item slot="header" color="light-blue">
          <div class="custom-flex-row flex-gap-px-8 ion-align-items-center w-full">
            <fa-icon *ngIf="prompt.isTouched && !prompt.isValid"
                     style="color: #cf355a;"
                     [icon]="faExclamationCircle"></fa-icon>
            <span class="grow">{{prompt.question_label}}</span>
            <span class="">(Min: {{prompt.min || 'No Minimum'}}, Max: {{prompt.max || 'Unlimited'}})
            </span>
          </div>
        </ion-item>

        <ion-list slot="content">
          <div #warningTarget
               *ngIf="invalidPromptIndex > NO_PROMPTS_FOUND && selectedPrompts[invalidPromptIndex]?.id === prompt.id"
               class="warning-text">Select at least {{ prompt.min }} item(s) to continue with order
          </div>
          <ion-radio-group *ngIf="prompt.max === 1 && prompt.min === 1; else checkboxList">
            <ion-item *ngFor="let option of prompt.formattedOptions" mode="md" lines="none" class="bordered-item"
                      (click)="onSelect(prompt, option)">
              <ion-radio slot="start"
                         class="ion-no-margin ion-margin-end"
                         [value]="option" [disabled]="option.soldOut"></ion-radio>
              <ng-container *ngTemplateOutlet="optLabel; context: {option}">
              </ng-container>
              <ion-badge *ngIf="option.soldOut" slot="end" color="danger">Sold Out</ion-badge>
            </ion-item>
          </ion-radio-group>
        </ion-list>

        <ng-template #checkboxList>
          <ion-item *ngFor="let option of prompt.formattedOptions" mode="md" lines="none"
                    (click)="onSelect(prompt, option)" class="bordered-item">
            <ion-checkbox slot="start"
                          class="ion-no-margin ion-margin-end"
                          [disabled]="(prompt.selectedOptions && (prompt.max && prompt.selectedOptions.length >= prompt.max) && !(option | isOptionSelectedPipe:prompt.selectedOptions)) || option.soldOut"></ion-checkbox>
            <ng-container *ngTemplateOutlet="optLabel; context: {option}">
            </ng-container>
            <ion-badge *ngIf="option.soldOut" slot="end" color="danger" class="ion-no-margin ion-margin-start">
              Sold Out
            </ion-badge>
          </ion-item>
        </ng-template>
      </ion-accordion>
    </ion-accordion-group>
  </ion-list>
</ng-template>